import SEO from "components/Seo";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import { PropsWithChildren } from "react";
import AboutSidebarContent from "../components/Faqs/FaqSidebar/AboutSidebarContent";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import useLastPath from "../customHooks/useLastPath";
import useModal from "../customHooks/useModal";

const AboutLayout: React.FC<PropsWithChildren<AboutLayoutProps>> = (props) => {
  const { handleCloseModal: handleCloseFaqsOffCanvas } = useModal();
  const { locale } = useRouter();
  const cont = props.pages;
  const lastPath = useLastPath();

  const paths = [
    { path: "/about/about", name: "about" },
    { path: "/about/molham", name: "molham" },
    { path: "/about/mission", name: "mission" },

    { path: "/about/programs", name: "programs" },
    { path: "/about/legalnotice", name: "legalnotice" },
    {
      path: "/about/reports",
      name: "reports",
      description: "annual-reports-description",
    },
  ];

  const content = paths.map((path) => {
    return {
      content: cont?.find((page) => page.slug === path.name) || {
        title: path.name,
        description: path.description || path.name,
        body: path.name,
      },
      path,
    };
  });
  const SideBarContent = (
    <AboutSidebarContent
      content={content}
      handleCloseFaqsOffCanvas={handleCloseFaqsOffCanvas}
      lastPath={lastPath}
    />
  );
  const { t } = useTranslation("common");
  const title =
    content.find((item) => item.path.name === lastPath)?.content?.title?.[
      locale
    ] || t(content.find((item) => item.path.name === lastPath)?.path?.name);
  const description =
    content.find((item) => item.path.name === lastPath)?.content?.description[
      locale
    ] ||
    t(content.find((item) => item.path.name === lastPath)?.path?.description) ||
    t(content.find((item) => item.path.name === lastPath)?.path?.name);
  return (
    <>
      <SEO title={title} description={description} />
      <div className="cs-sidebar-enabled pt-2 pt-sm-0 h-100">
        <div className="container-fluid px-0 container-md px-md-4 overflow-hidden h-100">
          <div className="row h-100">
            <div className="cs-sidebar col-lg-3 pt-lg-4 d-none d-lg-block px-4  ">
              {SideBarContent}
            </div>
            <div className="col-lg-9 cs-content pt-lg-0">
              <div className="d-flex align-items-center">
                <CustomJumbotron
                  title={title}
                  desc={description}
                  p="py-4 px-0 px-4 px-lg-0"
                  breadCrumbM="my-0"
                  m="mt-0"
                  className="mt-0 border-bottom"
                  customBreadCrumbs={
                    <CustomBreadCrumbs
                      transformedLabel={(label) => {
                        if (label === "about") return t("header_about");
                        return (
                          content.find((item) => item.path.name === lastPath)
                            ?.content?.title[locale] ||
                          t(
                            content.find((item) => item.path.name === lastPath)
                              ?.path?.name
                          )
                        );
                      }}
                    />
                  }
                />
              </div>
              <div className="container px-0 px-md-0"> {props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutLayout;
